"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Misinformation9 = void 0;
const Card_1 = require("../../Card");
const CardType_1 = require("../../CardType");
const CardName_1 = require("../../../CardName");
class Misinformation9 extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.MISINFORMATION_9,
            cost: 0,
            metadata: {
                cardNumber: 'Z02',
            },
        });
    }
    play() {
        return undefined;
    }
}
exports.Misinformation9 = Misinformation9;
//# sourceMappingURL=Misinformation9.js.map